import { BaseRequest, IBaseRequest } from "../../BaseRequest";
import { Filter, toFilterXml } from "../../dataObjects/Filter";
import { Order, toOrderXml } from "../../dataObjects/Order";

export interface Parent {
    id: number;
    type: string;
}
function toParentXml(p:Parent):string{
    return `<PARENT>
    <id>${p.id}</id>
    <type>${p.type}</type>
    </PARENT>`;
}

export interface IListFPARequest2 extends IBaseRequest{
    limit?: number;
    offset?: number;
    orderBy?: string;
    countOnly?: boolean;
    flatView?: boolean;
    includeSlave?: boolean;
    fulltext?: string;
    parent?: Parent;
    folderFilter?: Filter;
    projectFilter?: Filter;
    activityFilter?: Filter;
    ORDER?: Order;    
}

export type IListFPARequest2Options = Omit<
    IListFPARequest2,
    keyof IBaseRequest
>;

export class ListFPARequest2 extends BaseRequest implements IListFPARequest2 {
    limit?: number;
    offset?: number;
    orderBy?: string;
    countOnly?: boolean;
    flatView?: boolean;
    includeSlave?: boolean;
    fulltext?: string;
    parent?: Parent;
    folderFilter?: Filter;
    projectFilter?: Filter;
    activityFilter?: Filter;
    ORDER?: Order;    

    constructor(server: string, 
        session: string,
        otherOptions: IListFPARequest2Options) {
            super(server, session);
            this.limit = otherOptions.limit;
            this.offset = otherOptions.offset;
            this.orderBy = otherOptions.orderBy;
            this.countOnly = otherOptions.countOnly;
            this.flatView = otherOptions.flatView;
            this.includeSlave = otherOptions.includeSlave;
            this.fulltext = otherOptions.fulltext;
            this.parent = otherOptions.parent;
            this.folderFilter = otherOptions.folderFilter;
            this.projectFilter = otherOptions.projectFilter;
            this.activityFilter = otherOptions.activityFilter;
            this.ORDER = otherOptions.ORDER;
    }

    toXml(): string {
        var parameters:string = super.toXml();
        parameters += this.makeNode(this.limit, 'limit');
        parameters += this.makeNode(this.offset, 'offset');
        parameters += this.makeNode(this.orderBy, 'orderBy');
        parameters += this.makeNode(this.countOnly, 'countOnly');
        parameters += this.makeNode(this.flatView, 'flatView');
        parameters += this.makeNode(this.includeSlave, 'includeSlave');
        parameters += this.makeNode(this.fulltext, 'fulltext');
        if(this.parent) parameters += toParentXml(this.parent);
        if(this.folderFilter) parameters += toFilterXml(this.folderFilter, "FILTER_FOLDER");
        if(this.projectFilter) parameters += toFilterXml(this.projectFilter, "FILTER_PROJECT");
        if(this.activityFilter) parameters += toFilterXml(this.activityFilter, "FILTER_ACTIVITY");
        if(this.ORDER) parameters += toOrderXml(this.ORDER);

        return super.wrapperXml("ListFPA", parameters);
    }
}